module.exports = __webpack_public_path__ + "static/media/AOI-Guideline.ad599fee.pdf";